import { createChartSlide } from '../helpers/chart_slide';
import { createTableSlide } from '../helpers/table_slide';

/**
 * Renders the original Report/Survey-style payload containing a top-level chart and/or table.
 * This remains isolated until those callers migrate to the canonical presentation model.
 *
 * @param {Object} options
 * @param {Object} options.footer
 * @param {Object} options.item
 * @param {Object} options.pptx
 */
export const renderLegacyChartTableItem = ({ footer, item, pptx }) => {
  const { chart, table } = item;
  const brokenBy = table?.columns[0]?.Header;

  if (chart) {
    createChartSlide({
      ...footer,
      brokenBy,
      chart,
      pptx,
    });
  }

  if (table) {
    createTableSlide({
      ...footer,
      pptx,
      table,
    });
  }
};
